export default `
  query getPayUMethods($input: GetPayUMethodsInput) {
    getPayUMethods(input: $input) {
      name
      brandImageUrl
      status
      value
      sort
    }
  }
`;
